import { Badge, ErrorMessage, Label, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { useLabelProperties } from "./LabelProperties";

export const DraftLabelComponent: FC<IControlAttributes> = ({
    control, className, children, props
}) => {
    const { status, error, properties, draftText } = useLabelProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Label
            </Badge>
            <Label className={className} iconClassName="me-1" {...properties} label={draftText}>
                {children}
            </Label>
        </div>)
}
